<template>
  <label class="base-label">
    <slot />
  </label>
</template>

<script>
export default {
  name: "BaseLabel",
};
</script>

<style lang="scss" scoped>
@import "./base-label.scss";
</style>
